"use client";

import { useState, useEffect } from "react";
// import Link from "next/link";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Menu, X } from "lucide-react";
import { cn } from "@/lib/utils";
// import { ModeToggle } from "../mode-toggle";
import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";
export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrolled]);

  return (
    <nav
      className={cn(
        "fixed top-0 w-full z-50 transition-all duration-300",
        scrolled
          ? "bg-background/95 backdrop-blur-md shadow-md py-3"
          : "bg-transparent py-5"
      )}
    >
      <div className="container mx-auto px-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          {/* <LayoutDashboard className="h-8 w-8 text-primary" /> */}
          <img src={logo} width={100} alt="logo" className="h-10 w-auto" />
          <span className="text-xl font-bold bg-gradient-to-r from-chart-1 to-chart-2   bg-clip-text">
            finanza.lat
          </span>
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-6">
          <a
            href="#caracteristicas"
            className="text-sm font-medium hover:text-primary transition-colors"
          >
            Características
          </a>
          <a
            href="#funcionamien"
            className="text-sm font-medium hover:text-primary transition-colors"
          >
            Cómo funciona
          </a>
          <a
            href="#testimonios"
            className="text-sm font-medium hover:text-primary transition-colors"
          >
            Testimonios
          </a>
          <a
            href="#precios"
            className="text-sm font-medium hover:text-primary transition-colors"
          >
            Precios
          </a>
          <a
            href="#faq"
            className="text-sm font-medium hover:text-primary transition-colors"
          >
            FAQ
          </a>
        </div>

        <div className="hidden md:flex items-center gap-4">
          {/* <ModeToggle /> */}
          <Button variant="outline" size="sm">
            <Link to={"/login"}>Iniciar sesión</Link>
          </Button>
          <Button
            className="bg-gradient-to-r from-chart-1 to-chart-2 hover:from-chart-1/90 hover:to-chart-2/90 text-white"
            size="sm"
          >
            <Link to={"/register"}>Registrarse</Link>
          </Button>
        </div>

        {/* Mobile Navigation Button */}
        <div className="flex md:hidden items-center gap-2">
          {/* <ModeToggle /> */}
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </Button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {isOpen && (
        <div className="md:hidden bg-background/95 backdrop-blur-md shadow-md">
          <div className="container mx-auto px-4 py-4 flex flex-col gap-4">
            <Link
              to="#caracteristicas"
              onClick={() => setIsOpen(false)}
              className="py-2 text-sm font-medium hover:text-primary transition-colors"
            >
              Características
            </Link>
            <Link
              to="#funcionamiento"
              onClick={() => setIsOpen(false)}
              className="py-2 text-sm font-medium hover:text-primary transition-colors"
            >
              Cómo funciona
            </Link>
            <Link
              to="#testimonios"
              onClick={() => setIsOpen(false)}
              className="py-2 text-sm font-medium hover:text-primary transition-colors"
            >
              Testimonios
            </Link>
            <Link
              to="#precios"
              onClick={() => setIsOpen(false)}
              className="py-2 text-sm font-medium hover:text-primary transition-colors"
            >
              Precios
            </Link>
            <Link
              to="#faq"
              onClick={() => setIsOpen(false)}
              className="py-2 text-sm font-medium hover:text-primary transition-colors"
            >
              FAQ
            </Link>
            <div className="flex flex-col gap-2 pt-2">
              <Button variant="outline" className="w-full">
                Iniciar sesión
              </Button>
              <Button className="w-full bg-gradient-to-r from-chart-1 to-chart-2 hover:from-chart-1/90 hover:to-chart-2/90 text-white">
                Registrarse
              </Button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
